import { ProgressBar } from '@sgme/ui';
import type { PendingStatusProps } from 'components/PostTrade/ProductModification/components/PendingStatus.connect';
import { useProgressTimer } from 'hooks/useProgressTimer';
import { FC } from 'react';
import { useIntl } from 'react-intl';

import { connectPendingStatus } from './PendingStatus.connect';

const Component: FC<PendingStatusProps> = ({ startingTimeInMillis, durationTimeInMillis }) => {
  const { formatMessage } = useIntl();
  const { progressInPercent } = useProgressTimer(startingTimeInMillis, durationTimeInMillis);
  return (
    <>
      <div className="w-100 alert alert-discreet-info d-flex mb-0 px-0 position-relative">
        <div className="card-body">
          <div>
            <strong className="align-middle ms-3">
              {formatMessage({ id: 'tradeAllocation.sidePanel.status.pending' })}
            </strong>
          </div>
        </div>
      </div>
      <ProgressBar size="sm" color="info" value={progressInPercent} />
    </>
  );
};

Component.displayName = 'PendingStatus';

export const PendingStatus = connectPendingStatus(Component);
